import React from 'react';
import { Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface PageHeaderProps {
  title: string;
  icon?: SvgIconComponent;
  subtitle?: string;
  actions?: React.ReactNode;
  centerOnMobile?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  icon: Icon,
  subtitle,
  actions,
  centerOnMobile = true,
}) => {
  return (
    <Box
      sx={{
        mb: { xs: 2, sm: 3 },
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: { 
          xs: centerOnMobile ? 'center' : 'flex-start', 
          sm: 'flex-start' 
        },
        gap: { xs: 1, sm: 2 },
        textAlign: { xs: centerOnMobile ? 'center' : 'left', sm: 'left' },
      }}
    >
      {/* Title Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {Icon && (
          <Icon
            sx={{
              fontSize: { xs: 28, sm: 32 },
              color: '#1565c0',
              display: { xs: 'none', sm: 'block' }, // Hide icon on mobile to save space
            }}
          />
        )}
        <Box>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 'bold',
              color: '#1565c0',
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
              lineHeight: 1.2,
              mb: subtitle ? 0.5 : 0,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                fontSize: { xs: '0.875rem', sm: '1rem' },
                fontWeight: 500,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Actions Section */}
      {actions && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            flexShrink: 0,
            width: { xs: '100%', sm: 'auto' },
            justifyContent: { xs: 'center', sm: 'flex-end' },
          }}
        >
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default PageHeader;
